import ZebraBtLe from "@/lib/printer/ZebraBtLe";

export default {
    drivers: {
        ZebraBtLe,
    },

    async can(printer_config) {
        if (!Array.isArray(printer_config))
            return false

        for (const config of printer_config) {
            const d = config?.driver || config
            if (this.drivers[d]) {
                if (await this.drivers[d].can()) {
                    console.log('Printer selected driver ' + d + ' with config', config)
                    return {config, driver: this.drivers[d]}
                }
            }
        }

        console.log('Printer no driver found for config', printer_config)
    },

    async print(printer_config, printText, copies) {
        const {config, driver} = await this.can(printer_config) || {}
        if (!driver)
            throw new Error("No print driver available")

        return await driver.print(config, printText, copies)
    }
}